import { useSearchParams } from "react-router-dom";

export const usePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);

  const currentPage = params.get("page") || "1";

  const incrementPage = () => {
    params.set("page", (parseInt(currentPage) + 1).toString());
    setSearchParams(params);
  };

  const decrementPage = () => {
    params.set("page", (parseInt(currentPage) - 1).toString());
    setSearchParams(params);
  };

  return {
    currentPage,
    incrementPage,
    decrementPage,
  };
};
